import buildgroupTemplate from '../views/partials/buildgroup.html';

export function buildgroup() {
  return {
    template: buildgroupTemplate,
  }
}
